import validation_messages from 'messages/validation_messages';

export const CUSTOMER_UPLOAD_MAX_SIZE_BYTES = 20 * 1024 * 1024;
export const CUSTOMER_UPLOAD_MAX_SIZE_MB = 20;

const allowedExtensions = [
  'avi',
  'csv',
  'doc',
  'docx',
  'jpeg',
  'jpg',
  'json',
  'log',
  'm4a',
  'md',
  'mov',
  'mp3',
  'mp4',
  'odp',
  'ods',
  'odt',
  'oga',
  'ogg',
  'ogv',
  'pdf',
  'png',
  'ppt',
  'pptx',
  'txt',
  'wav',
  'webp',
  'webm',
  'xls',
  'xlsx',
];

const blockedExtensions = new Set([
  'app',
  'appimage',
  'asp',
  'aspx',
  'bash',
  'bat',
  'bin',
  'cgi',
  'cmd',
  'com',
  'command',
  'csh',
  'dmg',
  'dll',
  'exe',
  'fish',
  'htm',
  'html',
  'jar',
  'js',
  'jse',
  'jsp',
  'ksh',
  'msi',
  'php',
  'pkg',
  'pl',
  'ps1',
  'psm1',
  'py',
  'rb',
  'run',
  'scr',
  'sh',
  'svg',
  'vbe',
  'vbs',
  'wsf',
  'wsh',
  'xhtml',
  'xml',
  'zsh',
]);

export const CUSTOMER_UPLOAD_ACCEPTED_TYPES = allowedExtensions.map(extension => `.${extension}`);

const getFileExtension = (fileName: string): string => {
  const lastPart = fileName.split('.').pop();
  if (!lastPart || lastPart === fileName) return '';
  return lastPart.toLowerCase();
};

export const buildCustomerUploadFileValidator =
  (t: (value: any, options?: Record<string, unknown>) => string) =>
  (file: File): string | null => {
    const { name, size } = file;
    const extension = getFileExtension(name);

    if (!extension || blockedExtensions.has(extension) || !allowedExtensions.includes(extension)) {
      return t(validation_messages.file_type_not_allowed);
    }

    if (size > CUSTOMER_UPLOAD_MAX_SIZE_BYTES) {
      return t(validation_messages.file_too_large, { maxSizeMb: CUSTOMER_UPLOAD_MAX_SIZE_MB });
    }

    return null;
  };
